import React from "react";

import { CircularProgress } from "@material-ui/core";

import useStyles from "./styles";
import { ProgressProps } from "./types";

const Progress = ({ isModule = false }: ProgressProps) => {
  const styles = useStyles();

  return (
    <div className={isModule ? styles.module : styles.fullPage}>
      <CircularProgress />
    </div>
  );
};

export default Progress;
